import { useEffect, useState } from "react";
import { t } from "i18next";
import { getMyModuleServer, importAIModules, removeAIModules } from "common-lib";

export type EpochModule = { specId: string; serverAddress: string; modelUuid: string; [key: string]: any };

interface Params {
  modelUuid?: string | null;
  serverAddress?: string;
  specId: string;
  enabled?: boolean;
}

/**
 * epoch 학습 중 저장된 모델(epochTrainModel)을 AI 서버에 따로 올려 추론에 쓴다.
 * AI 서버가 uuid로 모델을 찾으므로 검사모델 승격 없이 그대로 import한다.
 * 언마운트/비활성화되면 내려서 학습 중인 서버의 메모리를 돌려준다.
 */
export function useEpochModelModule({ modelUuid, serverAddress, specId, enabled = true }: Params) {
  const [module, setModule] = useState<EpochModule | null>(null);
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled || !serverAddress || !modelUuid) {
      setModule(null);
      setMsg(null);
      return;
    }

    let cancelled = false;
    setModule(null);
    setMsg(t("LoadingModelsMsg"));

    (async () => {
      try {
        // 이전 모델 연결 해제는 백엔드 import가 처리한다 (히트맵 spec 한정)
        await importAIModules(specId, false, false, true, serverAddress, null, modelUuid);
        const res = await getMyModuleServer(specId, null);
        if (cancelled) return;

        if (!res?.module) throw new Error(res?.message ?? t("NoConnectedModuleMsg"));
        setModule({ specId, serverAddress, ...res.module, modelUuid });
        setMsg(null);
      } catch (error: any) {
        if (!cancelled) setMsg(error?.response?.data?.message ?? error?.message ?? t("NoConnectedModuleMsg"));
      }
    })();

    return () => {
      cancelled = true;
      removeAIModules(serverAddress, specId).catch(() => {});
    };
  }, [modelUuid, serverAddress, specId, enabled]);

  return { module, msg };
}
